import logger from 'redux-logger';
import thunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import { createStore, applyMiddleware, combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
import authReducer from './components/auth/auth-reducer';
import snackbarsReducer from './components/snackbars/snackbars-reducer';
import layoutReducer from './components/layout/layout-reducer';
import availableDriversReducer from './components/available-drivers/available-drivers-reducer';
import businessAccountsReducer from './components/business-accounts/business-accounts-reducer';
import availableDriversMapReducer from './components/available-drivers-map/available-drivers-map-reducer';
import usersAndPermissionsReducer from './components/users-and-permissions/users-and-permissions-reducer';
import pastBookingsReducer from './components/past-bookings/past-bookings-reducer';
import scheduledBookingsReducer from './components/scheduled-bookings/scheduled-bookings-reducer';
import liveBookingsReducer from './components/live-bookings/live-bookings-reducer';

const persistConfig = { // root persist config
  key: 'root',
  storage: storage,
  whitelist: ['layout']
};

const authPersistConfig = {
  key: 'auth',
  storage: storage,
  whitelist: ['isLoggedIn', 'rememberMe', 'rememberedEmail']
};

const reducer = combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
  snackbars: snackbarsReducer,
  layout: layoutReducer,
  availableDrivers: availableDriversReducer,
  businessAccounts: businessAccountsReducer,
  availableDriversMap: availableDriversMapReducer,
  usersAndPermissions: usersAndPermissionsReducer,
  pastBookings: pastBookingsReducer,
  scheduledBookings: scheduledBookingsReducer,
  liveBookings: liveBookingsReducer
});

const persistedReducer = persistReducer(persistConfig, reducer);

// Add logger to middleware if not in production:
const production = `${process.env.REACT_APP_API_URL}` === 'https://api.kiffgo.com/';
let middleware = applyMiddleware(thunk);
if (!production) middleware = applyMiddleware(thunk, logger);

export const store = createStore(
  persistedReducer,
  middleware
);

export const persistedStore = persistStore(store);



// WEBPACK FOOTER //
// ./src/Store.js